<template>
    <div class="servicesWrap">
      <div class="profile-card">
        <div class="profile-header">
          <div class="avatar"><img src="https://h5.tc-rescue.com/snServices/images/icon_touxiang.png"></div>
          <div class="user-info"><h2>李烧烧</h2><p>13652***1253</p></div>
        </div>
        <div class="stats">
          <div class="stat-item"><div class="stat-value">5次</div><div class="stat-label">洗车</div></div>
          <div class="stat-item"><div class="stat-value">2次</div><div class="stat-label">保养</div></div>
          <div class="stat-item"><div class="stat-value">3次</div><div class="stat-label">代驾</div></div>
          <div class="stat-item"><div class="stat-value">0次</div><div class="stat-label">玻璃修复</div></div>
        </div>
      </div>
      <h3 class="servicesTitle">服务项目</h3>
<!--      <van-cell v-for="item in services" :title="item.name" value="立即预约" is-link icon="location-o" :url="item.link"/>-->
      <div class="list-item" v-for="item in services">
        <img :src="'https://h5.tc-rescue.com/snServices/images/' + item.icon" class="item-image">
        <div class="item-content">
          <div class="item-title">{{ item.name }}</div>
          <div class="item-desc">{{ item.desc }}</div>
<!--          <div class="item-meta">2025-08-01 · 类别1</div>-->
        </div>
        <button class="item-button" @click="toDetail(item)">立即体验</button>
      </div>
      <van-tabbar v-model:active="active">
        <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item name="user" icon="friends-o" @click="$router.push({path: '/servicesUser'})">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import {orderEvaluate} from "@/apis/rescue";

export default {
    data(){
        return {
          active: "home",
          services:[
            {name: "车辆安全服务", desc: "配件质量（原厂/认证配件），技术认证（技师资质、设备标准）,刹车系统全面检测,专业清洗冷却系统。", icon: "icon_repair.png", link: "/servicesProject?type=1"},
            {name: "洗车服务", desc: "在汽车保养领域，洗车是维护轿车美观与性能的基础且关键的环节。", icon: "icon_wash.png", link: "/servicesProject?type=2"},
            {name: "油漆修复", desc: "专业的技术、优质的材料和规范的流程，为车主提供全方位的漆面修复与改色服务。", icon: "icon_pen.png", link: "/servicesProject?type=3"},
            {name: "代驾服务", desc: "提供专业、安全、便捷的驾驶替代服务，涵盖多种场景，满足不同用户的出行需求。", icon: "icon_drive.png", link: "/servicesDetail?type=4"},
            {name: "维修保养服务", desc: "在常规保养基础上，对车辆各系统进行更全面、细致的检查、清洁、修复和更换", icon: "icon_baoyang.png", link: "/servicesProject?type=5"},
            // {name: "全部服务", desc: "更多其他项目陆续开放中，请多关注我们的资讯。", icon: "icon_all.png"},
          ],

        }
    },
    created(){
      localStorage.user_phone = '13652***1253';
      localStorage.user_nick = '李烧烧';
      localStorage.merchant_id = 'SHOP-AE';
    },
    mounted(){

    },
    methods: {
        onSubmit(){
            let that = this;
            let data = {
                ...this.form
            }

            orderEvaluate(data).then((res)=>{
                that.$toast(res.data.info);
                that.submitLoading = false;
            })
        },
        toDetail(row){
          location.hash = row.link;
          this.$router.push({path: row.link})
        }
    }
}
</script>

<style lang='scss' scoped>

</style>
